import Reflux from 'reflux';

import Chip from "@reactComponents/lds/chips/Chip";
import { FacetSearchAliasSearchActions } from '../../stores/actions/facetSearch/aliasSearchActions';
import FacetSearchStore from '../../stores/facetSearchStore';
import { aliasSearchIcon } from '@reactComponents/facetSearch/facetSearchUtils';

// TODO: remove this once we clean up the DB (#188859861)
const removeEmoji = (str) => {
  return str.replace(
    /(_ZAP Search|_Prebuilt Search|\u26a1|\u2b50|[\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
    ""
  );
};

const FacetSearchCriteriaAliasSearch = createReactClass({
  mixins: [Reflux.connectFilter(FacetSearchStore, ({ aliasSearch: aliasSearchRefs }) => aliasSearchRefs)],
  render() {
    const { aliasSearchRefs } = this.state;

    if (aliasSearchRefs) {
      const locked = ((Zymewire.original_feed_query || {}).alias_search_refs || []).length > 0
      let aliasSearchContent = [];
      aliasSearchRefs.forEach((aliasSearchRef) => {
        const displayValue = removeEmoji(aliasSearchRef.display);
        const ref = aliasSearchRef.ref;
        aliasSearchContent.push(
          <AliasSearchAppliedFilterEntry
            aliasSearchRefsKey={ref}
            displayValue={displayValue}
            originalDisplayValue={aliasSearchRef.display}
            key={ref + 'entry'}
            locked={locked}
          />
        );
      });
      return (
        <>
          {aliasSearchContent}
        </>
      );
    }
    else {
      return null;
    }
  }
});

const AliasSearchAppliedFilterEntry = ({
  aliasSearchRefsKey,
  displayValue,
  originalDisplayValue,
  locked,
}) => {

  let removeAliasSearch = () => {
    FacetSearchAliasSearchActions.removeAliasSearchRefs({ ref: aliasSearchRefsKey, display: originalDisplayValue });
    return false;
  };

  return (
    <Chip
      className="search_filter_applied_chip"
      label={displayValue}
      leadingIcon={aliasSearchIcon(I18n.locale)}
      size="small"
      {...!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: removeAliasSearch,
      }}
      variant="secondary"
    />
  );
};

window.FacetSearchCriteriaAliasSearch = FacetSearchCriteriaAliasSearch;
export default FacetSearchCriteriaAliasSearch;

